<template>
  <div>
    <div id="page" data-swup="0" class="device-is-android">
      <header-bar></header-bar>

      <footer-bar></footer-bar>
      <div
        class="page-content header-clear-medium has-footer-menu"
        style="transform: translateX(0px)"
      >
        <div class="card card-style">
          <div class="mb-0 content">
            <!-- {{tasks.length}} {{ $route.params.id }} -->
            <template v-for="task in tasks">
              <router-link
                :to="getLink(task)"
                :key="task.id"
              >
                <div class="mb-3 d-flex">
                  <div>
                    <img
                      :src="`${task.defaultAttachmentUrl}?h=70&w=70&mode=crop`"
                      width="70"
                      class="rounded-sm"
                    />
                  </div>
                  <div>
                    <p class="ps-3 line-height-s color-theme mb-1">
                      {{ getLangText(task) }}
                    </p>
                  </div>
                </div>
              </router-link>
              <div class="mb-3 divider"></div>

              <!-- <div
              class="mb-3 d-flex"
              @click="handleDetailModal({ show: true, id: task.id })"
            >
              <div>
                <a
                  ><img
                    :src="`${task.defaultAttachmentUrl}?h=70&w=70&mode=crop`"
                    width="70"
                    class="rounded-sm"
                /></a>
              </div>
              <div>
                <a>
                  <p class="mb-1 ps-3 line-height-s color-theme">
                    {{ task.task }}
                  </p>
                </a>
              </div>
            </div>
            <div class="mb-3 divider"></div> -->
            </template>
          </div>
        </div>
      </div>

      <div class="page-bg">
        <div></div>
      </div>

      <div class="divider divider-margins"></div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";
export default {
  components: {
    footerBar,
    headerBar,
  },
  data() {
    return {
      tasks: [],
    };
  },
  methods: {
    ...mapActions(["handleDetailModal"]),
    getLangText(task) {
      let lng = this.$i18n.locale;
      if (lng == "en") {
        return task.st5 ?? task.task;
      } else if (lng == "ru") {
        return task.st4 ?? task.task;
      } else if (lng == "cn") {
        return task.st6 ?? task.task;
      } else {
        return task.task;
      }
    },
    getLink(task){
      if(task.locTypeId2!=null)
        return `/w/medeelel/${task.locTypeId2}`;
      else
        return `/w/medeelel/${task.locTypeId1}`;
    }
  },
  mounted() {
    // this.tasks = _.sortBy(
    //   this.$store.state.app.pages.filter(
    //     (x) => x.parentId == this.$route.params.id && x.i2 == 1
    //   ),
    //   "ord",
    //   "asc"
    // );
    request({
      api: { method: "POST", url: "taskCore/getCoreList" },
      data: {
        skip: 0,
        size: 1000,
        ot: 356,
        model: {
          isPublic: true,
          locTypeId1: this.$route.params.id,
        },
      },
      store: this.$store,
    }).then((res) => {
      this.tasks = _.sortBy(
        res.data.tasks.filter(
          (x) => x.locTypeId1 == this.$route.params.id && x.id != 3347898
        ),
        "ord",
        "asc"
      );
    });
    // request({
    //   api: { method: "POST", url: "taskCore/getCoreList" },
    //   data: {
    //     skip: 0,
    //     size: 10,
    //     ot: 357,
    //     model: {
    //       isPublic: true,
    //       locTypeId1: 153362,
    //     },
    //   },
    //   store: this.$store,
    // }).then((res) => {
    //   this.tasks = _.sortBy(res.data.tasks, "ord", "asc");
    // });
  },
};
</script>
